import { AllOrganizationData, AllWorkspaceData } from './types';
import { matchPath } from 'react-router-dom';
import { useKeywordsStore } from '@/stores/keywordsStore';

export const ACCESS = {
  ALL: ['view', 'create', 'update', 'delete'] as const,
  VIEW: ['view'] as const,
  UPDATE: ['update'] as const,
  CREATE: ['create'] as const,
  DELETE: ['delete'] as const,
  NONE: [] as const,
} as const;

export function getWorkspaceConstraints(
  pathname: string,
  overrides?: Partial<AllWorkspaceData>,
): AllWorkspaceData {
  const connectorId = getConnectorId(pathname) ?? '';
  const numOfExistingKeywords = useKeywordsStore.getState().keywords.length;
  const numOfAddingKeywords = 0;
  return {
    connectorId,
    numOfAddingKeywords,
    numOfExistingKeywords,
    ...overrides,
  };
}

export function getConnectorId(pathname: string): string | null {
  const match =
    matchPath('/connectors/info/:connectorName', pathname) ??
    matchPath('/connectors/edit/:connectorName', pathname);
  const connectorName = match?.params.connectorName;
  return connectorName || null;
}

export function getOrganizationConstraints(
  overrides?: Partial<AllOrganizationData>,
): AllOrganizationData {
  return {
    currentInvitationsNum: 0,
    currentUsersNum: 0,
    newInvitationsNum: 0,
    ...overrides,
  };
}
